import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { asCurrency } from '../utils/numberUtils';
import styles from './styles';

import type Address from '../models/Address';

interface ListingStripeProps {
  listing: Address;
  customPrice: number | null;
  rentZestimateRangeLow: number;
  rentZestimateRangeHigh: number;
}

const ListingStripe: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<ListingStripeProps>>> = (
  props,
) => {
  const { listing, customPrice, rentZestimateRangeLow, rentZestimateRangeHigh } = props;
  const { street, unit, city, state, zip, beds, baths, sqft, rentZestimate } = listing;

  return (
    <View style={[styles.hero, styles.marginBottomSm]}>
      <View>
        <Text style={styles.h5}>
          {street} {unit && unit !== ' ' ? ', Unit ' + unit : ''}
        </Text>
        <Text style={styles.h5}>
          {city}, {state} {zip}
        </Text>
        <Text style={styles.h6}>
          {beds} bed • {baths} bath • {sqft} sq. ft.
        </Text>
      </View>
      <View style={styles.right}>
        <View style={styles.zestimateCard}>
          {customPrice ? (
            <>
              <Text style={styles.bodyHeading}>Custom rental price</Text>
              <Text style={styles.h3}>{asCurrency(customPrice)}/mo</Text>
            </>
          ) : (
            <>
              <Text style={styles.bodyHeading}>
                Your Rent Zestimate<Text style={styles.bodySup}>®</Text>
              </Text>
              <Text style={styles.h3}>{asCurrency(rentZestimate || '')}/mo</Text>
              <Text style={styles.body}>
                Rent Zestimate<Text style={styles.bodySup}>®</Text> range:{' '}
                <Text style={styles.bodyHeading}>
                  {asCurrency(rentZestimateRangeLow)} - {asCurrency(rentZestimateRangeHigh)}
                </Text>
              </Text>
            </>
          )}
        </View>
      </View>
    </View>
  );
};

export default ListingStripe;
